// Mock data para Coutin Agência

export const agencyInfo = {
  name: "Coutin Agência",
  tagline: "Excelência em Marketing e Produção Audiovisual",
  email: "agenciacoutin@gmail.com",
  phone: "+55 (45) 988068508",
  whatsapp: "5545988068508",
  instagram: "@coutinagencia",
  website: "www.agenciacoutin.com.br",
  logo: "https://customer-assets.emergentagent.com/job_coutin-academy/artifacts/78959pil_pod%20hub%20%28V%C3%ADdeo%20vertical%29.png"
};

export const premiumPlans = [
  {
    id: 1,
    title: "Filmagem por Diária",
    subtitle: "Cinematográfico 4K",
    featured: false,
    highlight: "Eventos · Institucional · Ads",
    description: "Diárias avulsas de filmagem profissional com equipe completa, câmeras Sony 4K, drones DJI Avata FPV e edição cinematográfica. Ideal para shows, eventos corporativos, vídeos institucionais, casamentos e ativações de marca.",
    features: [
      "Equipe profissional (operador + assistente)",
      "Câmeras Sony 4K + lentes profissionais",
      "Drones DJI Avata FPV indoor e outdoor",
      "Captação 120fps slow motion disponível",
      "Edição cinematográfica com color grading",
      "Entrega em até 7 dias úteis"
    ],
    cta: "Solicitar Orçamento",
    ctaMessage: "Olá! Gostaria de um orçamento para filmagem por diária. Detalhes do projeto:",
    image: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  },
  {
    id: 2,
    title: "Gestão Presencial Completa",
    subtitle: "O Queridinho",
    featured: true,
    highlight: "1 Visita Semanal · Equipe Completa",
    description: "Gestão total das suas redes sociais com nossa equipe presente no seu negócio toda semana. Filmagem com drones e Sony 4K, edição cinematográfica, criação de conteúdo estratégico, design gráfico e tráfego pago — tudo gerenciado por especialistas locais em Foz do Iguaçu.",
    features: [
      "Filmagem Semanal com Drones DJI e Câmeras Sony 4K",
      "Edição Cinematográfica + Color Grading",
      "Gestão Estratégica do Instagram + Tráfego Pago",
      "Design Gráfico: Panfletos, Folders, Flyers",
      "1 Visita Presencial Semanal no seu negócio",
      "Relatórios mensais de performance"
    ],
    cta: "Solicitar Orçamento",
    ctaMessage: "Olá! Tenho interesse no pacote de Gestão Presencial Completa. Gostaria de receber um orçamento personalizado.",
    image: "https://images.unsplash.com/photo-1549449882-a0a6be8af63d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  },
  {
    id: 3,
    title: "Sites de Alta Conversão",
    subtitle: "Performance Digital",
    featured: false,
    highlight: "Landing Pages · Institucionais · E-commerce",
    description: "Desenvolvemos sites rápidos, otimizados para Google (SEO local em Foz do Iguaçu) e estrategicamente projetados para transformar visitantes em clientes. Do briefing à hospedagem — tudo gerenciado por nossa equipe interna.",
    features: [
      "Design Exclusivo Mobile-First",
      "SEO Técnico para liderar buscas locais",
      "Integração com WhatsApp e Google Analytics",
      "Hospedagem + Domínio + SSL inclusos (1 ano)",
      "Painel de gestão de conteúdo (CMS)",
      "Manutenção estratégica opcional"
    ],
    cta: "Solicitar Orçamento",
    ctaMessage: "Olá! Quero desenvolver um site com a Coutin. Tipo de projeto:",
    image: "https://images.unsplash.com/photo-1487014679447-9f8336841d58?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
  }
];

export const academyCourses = [
  {
    id: 1,
    category: "Básico ao Avançado",
    title: "Pilotagem de Drone Profissional",
    duration: "40 horas",
    level: "Básico ao Avançado",
    description: "Domine a pilotagem de drones do zero até captações cinematográficas profissionais",
    modules: [
      "Fundamentos de pilotagem e segurança",
      "Legislação ANAC e autorização de voo",
      "Técnicas de captação aérea",
      "Movimentos cinematográficos",
      "Planejamento de voo e locações"
    ],
    image: "https://customer-assets.emergentagent.com/job_coutin-academy/artifacts/xbnzhtye_DJI_20260115102516_0019_D-2.png"
  },
  {
    id: 2,
    category: "Edição de Vídeo",
    title: "CapCut & Adobe Premiere Pro",
    duration: "35 horas",
    level: "Básico ao Avançado",
    description: "Edição profissional para redes sociais e produções cinematográficas",
    modules: [
      "CapCut: Edição rápida para redes sociais",
      "Adobe Premiere Pro: Fundamentos",
      "Técnicas de corte e transições",
      "Color grading e correção de cor",
      "Exportação otimizada para cada plataforma"
    ],
    image: "https://images.unsplash.com/photo-1640165715886-bd607330c46e"
  },
  {
    id: 3,
    category: "Fotografia",
    title: "Tratamento de Imagem - Lightroom",
    duration: "25 horas",
    level: "Intermediário ao Avançado",
    description: "Transforme suas fotos com técnicas profissionais de edição e retoque",
    modules: [
      "Interface e organização no Lightroom",
      "Ajustes básicos e exposição",
      "Correção de cor e balanço de branco",
      "Retoque e remoção de imperfeições",
      "Criação de presets personalizados"
    ],
    image: "https://customer-assets.emergentagent.com/job_coutin-academy/artifacts/k1z05yoo_DSC05591.JPG"
  },
  {
    id: 4,
    category: "Técnico",
    title: "Infraestrutura Windows & Formatação",
    duration: "30 horas",
    level: "Básico ao Intermediário",
    description: "Formação técnica completa para profissionais de TI e suporte",
    modules: [
      "Instalação e configuração do Windows",
      "Particionamento e formatação de discos",
      "Drivers e otimização de sistema",
      "Backup e recuperação de dados",
      "Rede e compartilhamento Windows",
      "Solução de problemas comuns"
    ],
    image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97"
  }
];

export const heroImages = {
  main: "https://customer-assets.emergentagent.com/job_coutin-academy/artifacts/0uqdk9wm_DSC03471.JPG",
  secondary: "https://customer-assets.emergentagent.com/job_coutin-academy/artifacts/i1hrrzqj_DSC03471.JPG"
};

export const stats = [
  { number: "500+", label: "Projetos Entregues" },
  { number: "10+", label: "Anos de Experiência" },
  { number: "98%", label: "Taxa de Satisfação" },
  { number: "5.0⭐", label: "Avaliação Google" }
];

export const portfolioCategories = [
  {
    id: 1,
    title: "Filmagens Imobiliárias FPV",
    description: "Tours virtuais cinematográficos para hotéis e imobiliárias com drone interno (DJI Avata)",
    image: "https://images.unsplash.com/photo-1728803106517-605ed0d69aad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxGUFYlMjBkcm9uZSUyMGluZG9vciUyMGhvdGVsJTIwbHV4dXJ5JTIwcmVhbCUyMGVzdGF0ZSUyMHRvdXJ8ZW58MHx8fHwxNzc3MDMxMTAwfDA&ixlib=rb-4.1.0&q=85",
    badge: "FPV Indoor"
  },
  {
    id: 2,
    title: "Eventos Esportivos",
    description: "Especialização em captação de alta velocidade: motocross, mergulho, competições e campeonatos",
    image: "https://images.unsplash.com/photo-1765520175575-3291323d5777?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxtb3RvY3Jvc3MlMjBhY3Rpb24lMjBzcG9ydHMlMjBwaG90b2dyYXBoeSUyMGhpZ2glMjBzcGVlZHxlbnwwfHx8fDE3NzcwMzExMDB8MA&ixlib=rb-4.1.0&q=85",
    badge: "Ação & Performance"
  },
  {
    id: 3,
    title: "Shows & Apresentações",
    description: "Cobertura de shows, patinação artística, apresentações culturais e eventos ao vivo",
    image: "https://customer-assets.emergentagent.com/job_coutin-academy/artifacts/k1z05yoo_DSC05591.JPG",
    badge: "Live Events"
  },
  {
    id: 4,
    title: "Turismo de Aventura",
    description: "Equipamento especializado para ecoturismo, trilhas e experiências outdoor",
    image: "https://images.unsplash.com/photo-1767731972407-9137f6d0f79f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxhZHZlbnR1cmUlMjB0b3VyaXNtJTIwb3V0ZG9vciUyMGhpa2luZyUyMG1vdW50YWlucyUyMGVxdWlwbWVudHxlbnwwfHx8fDE3NzcwMzExMDB8MA&ixlib=rb-4.1.0&q=85",
    badge: "Aventura 4K"
  }
];

export const googleReviews = {
  rating: 5.0,
  totalReviews: 8,
  totalInteractions: 280,
  profileUrl: "https://g.page/r/CV71PwTZvBxPEBM/review",
  photosUrl: "https://www.google.com/search?q=Coutin+Ag%C3%AAncia&stick=H4sIAAAAAAAA_-NgU1I1qLA0STOzNEw1MkxJtUhOMkyyMqgwSTNMTkpOsTQwMU5LMzVNXcTK75xfWpKZp-CYfnhVXnJmIgBbWBW5OwAAAA&hl=pt-BR&mat=CVbD_HMgWHt_ElcBTVDHnthWySFz2OCyx8lhFhKTayViSXwWSUJIwh-4hqfwJC-ke3paYNxlfkpQvIkY1tBpiM5uv7kuduvNWpbDJGoSrRgqzMJ8elvdYt2uhwSHyNrKz6Q&authuser=0#mpd=~9186032761360401238/promote/photos/mediatool",
  reviews: [
    {
      id: 1,
      author: "Rodrigo Camargo",
      rating: 5,
      text: "Trabalho de qualidade e profissionalismo, recomendo!!!",
      date: "Há 3 semanas",
      verified: true
    },
    {
      id: 2,
      author: "Daiane Flores",
      rating: 5,
      text: "Tive uma ótima experiência com a agência Picks, me entregou um excelente trabalho, e com o suporte do pacote diamante meu rendimento triplicou. Nunca vou me arrepender, não fico mais sem. 😁😁😁",
      date: "1 de março de 2024",
      verified: true
    },
    {
      id: 3,
      author: "Valter Mota",
      rating: 5,
      text: "O líder em muito tem como profissional seus equipamentos impressionam e suas entregas são muito rápidas. Recomendo muito!",
      date: "Há 2 horas",
      verified: true
    },
    {
      id: 4,
      author: "Valeria Santos",
      rating: 5,
      text: "Melhor designer de logotipos que achamos, preço bom e atendimento nota 10. Equipe extremamente competente!",
      date: "Há 2 horas",
      verified: true
    },
    {
      id: 5,
      author: "Crowley King",
      rating: 5,
      text: "Incrível! O trabalho tem norma, equipe de alto padrão.",
      date: "Há 3 horas",
      verified: true
    },
    {
      id: 6,
      author: "Viva Foz Hospedagem",
      rating: 5,
      text: "Coutin agente atender um pedido aqui só temos agradecer, o trabalho dela é diferenciado. Adoramos fazer esse trabalho nos seus imóveis!",
      date: "Há 2 semanas",
      verified: true
    },
    {
      id: 7,
      author: "Cliente Satisfeito",
      rating: 5,
      text: "Conheço pessoal, adoramos fazer esse trabalho. Profissionais de alto nível!",
      date: "Há 1 semana",
      verified: true
    }
  ]
};
